var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoCallsMade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z",
    fill: "#FDF2F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3359 20.8334L27.6884 23.7351C27.7512 23.7768 27.8241 23.8008 27.8994 23.8044C27.9746 23.808 28.0495 23.7911 28.1159 23.7555C28.1824 23.7199 28.2379 23.667 28.2767 23.6024C28.3154 23.5377 28.3359 23.4638 28.3359 23.3884V16.5584C28.336 16.4851 28.3166 16.4131 28.2799 16.3496C28.2432 16.2861 28.1904 16.2335 28.1268 16.197C28.0633 16.1605 27.9912 16.1414 27.9179 16.1416C27.8445 16.1419 27.7726 16.1614 27.7093 16.1984L23.3359 18.7501",
    stroke: "#E60076",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6641 15H13.3307C12.4103 15 11.6641 15.7462 11.6641 16.6667V23.3333C11.6641 24.2538 12.4103 25 13.3307 25H21.6641C22.5845 25 23.3307 24.2538 23.3307 23.3333V16.6667C23.3307 15.7462 22.5845 15 21.6641 15Z",
    stroke: "#E60076",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallsMade);
export default __webpack_public_path__ + "static/media/video-calls-made.ea10817655893409b4da56a9c2bb63da.svg";
export { ForwardRef as ReactComponent };